<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :amzFbaShipmentCode="params.code"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-fbaShipment-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
